module.exports = __webpack_public_path__ + "img/PRNT_06_mono_AE_00001.e4d1a954.png";